import type { AppDispatch } from '.'

/**
 * A lightweight holder for the Redux dispatch function.
 * Populated once in main.tsx at app startup so non-React modules (e.g. UAuthToken)
 * can dispatch actions without importing the store directly, which would create
 * a circular dependency through the API slice middleware chain.
 */
let _dispatch: AppDispatch | null = null

export const storeRef = {
  setDispatch(dispatch: AppDispatch): void {
    _dispatch = dispatch
  },
  dispatch(action: Parameters<AppDispatch>[0]): void {
    _dispatch?.(action)
  }
}
